// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_17vv3","story-body":"_19MrP"};